import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import i18n from 'simple-react-i18n'
import IAEauAction from '../../../../iaeau/IAEauAction'
import ToastrAction from '../../../../toastr/actions/ToastrAction'
import SimpleDatePicker from '../../../../components/forms/SimpleDatePicker'
import { DefaultDialogTitle } from '../../../../components/styled/Dialog'
import useParseJson from '../../../../utils/customHook/useParseJson'
import { STATION_TYPE_NAME } from '../../../constants/StationConstants'

const HydratecModes = {
    PREPA: 'PREPA',
    CRUE_INI: 'CRUE_INI',
    CRUE: 'CRUE',
    ACTU: 'ACTU',
}

// Date de début de simulation par défaut pour la réinitialisation (mode PREPA)
const DEFAULT_PREPA_START_DATE = moment('2024-09-01T00:00').valueOf()

// ZIP du dernier workspace du modèle Hydratec, toujours disponible à cette adresse (instance IAEau de prod)
const WORKSPACE_ZIP_URL = 'https://ia-eau.fr/contents/pythonscripts/HYDRATEK/workspace_1/AQUASYS.zip'

const HydratecParamsPanel = ({
    model = {},
    id,
    onChangeJob = () => {},
    onExecute = () => {},
}) => {
    const dispatch = useDispatch()
    const { json: modelParams } = useParseJson(model.params)

    const [resetDialogOpen, setResetDialogOpen] = useState(false)
    const [prepaStartDate, setPrepaStartDate] = useState(DEFAULT_PREPA_START_DATE)

    const changeMode = (mode) => {
        onChangeJob({ cron: mode === HydratecModes.CRUE_INI ? '0 0 * * * * *' : '0 0 8 * * * *' }, () => {
            const newModel = { ...model, statusCode: 7, params: JSON.stringify({ ...modelParams, mode }) }
            IAEauAction.updateModel(STATION_TYPE_NAME.hydrometry, id, newModel).then(() => {
                onExecute()
            })
        })
    }

    const resetModel = () => {
        const newModel = { ...model, statusCode: 7, params: JSON.stringify({ ...modelParams, mode: HydratecModes.PREPA, prepaStartDate }) }
        IAEauAction.updateModel(STATION_TYPE_NAME.hydrometry, id, newModel)
            .then(() => IAEauAction.launchModel(STATION_TYPE_NAME.hydrometry, id, newModel))
            .then(() => {
                dispatch(ToastrAction.success(i18n.jobLaunched))
                setResetDialogOpen(false)
            })
    }

    const downloadData = () => window.open(WORKSPACE_ZIP_URL, '_blank')

    return (
        <Grid container alignItems='center' spacing={1}>
            <Grid size={2}>
                Mode actuel : {modelParams.mode}
            </Grid>
            <Grid size={2}>
                <Button variant='contained' color='primary' disabled={modelParams.mode === HydratecModes.CRUE} onClick={() => changeMode(HydratecModes.CRUE_INI)}>Passer en mode CRUE</Button>
            </Grid>
            <Grid size={2}>
                <Button variant='contained' color='primary' disabled={modelParams.mode === HydratecModes.ACTU} onClick={() => changeMode(HydratecModes.ACTU)}>Stopper le mode CRUE</Button>
            </Grid>
            <Grid size={2}>
                <Button variant='contained' color='primary' onClick={() => setResetDialogOpen(true)}>{i18n.resetModel}</Button>
            </Grid>
            <Grid size={2}>
                <Button variant='outlined' color='primary' onClick={downloadData}>{i18n.downloadModelData}</Button>
            </Grid>
            <Dialog open={resetDialogOpen} onClose={() => setResetDialogOpen(false)} maxWidth='sm' fullWidth>
                <DefaultDialogTitle title={i18n.resetModel} onClose={() => setResetDialogOpen(false)} />
                <DialogContent>
                    <Grid container style={{ paddingTop: '10px' }}>
                        <Grid size={12}>
                            <SimpleDatePicker
                                label={i18n.simulationStartDate}
                                value={prepaStartDate}
                                onChange={date => setPrepaStartDate(date)}
                                withHour
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' color='primary' onClick={resetModel}>{i18n.validate}</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}

HydratecParamsPanel.propTypes = {
    id: PropTypes.string,
    model: PropTypes.shape({}),
    onExecute: PropTypes.func,
    onChangeJob: PropTypes.func,
}

export default HydratecParamsPanel